import {Divider} from '@/components/ui/divider/Divider'
import {PageCardWrapper, PageContent} from '@/components/ui/page-atoms/PageAtoms'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {MissingDataErrorBoundary} from '@/features/projects/components/missing-data-error-boundary/MissingDataErrorBoundary'
import {ProjectFormHeading} from '@/features/projects/components/project-form/project-form-heading/ProjectFormHeading'
import {TransformProjectFormProvider} from '@/features/projects/components/project-form/transform-project-form-provider/TransformProjectFormProvider'
import {TransformProjectFormSections} from '@/features/projects/components/project-form/transform-project-form-sections/TransformProjectFormSections'
import {TransformProjectConfirmationModal} from '@/features/projects/components/transform-project-confirmation-modal/TransformProjectConfirmationModal'
import {TransformProjectFormValidationSchema} from '@/features/projects/formSchemas'
import {ProjectExtended} from '@/features/projects/types'
import {useToggle} from '@/hooks/useToggle'
import {useTranslation} from '@/translations/i18n'
import {ErrorBoundary} from 'react-error-boundary'
import {Helmet} from 'react-helmet'
import {useOutletContext} from 'react-router-dom'
import {usePermissions} from '@/features/auth/store/store'
import {NoPermissionBox} from '@/components/commons/no-permission-box/NoPermissionBox'

export const ProjectTransform = () => {
    const {t} = useTranslation()
    const permissions = usePermissions()
    const {on: showConfirmationModal, off: hideConfirmationModal, isActive: isConfirmationModalVisible} = useToggle()
    const {project} = useOutletContext<{project: ProjectExtended}>()

    if (!permissions?.projects.write) {
        return <NoPermissionBox />
    }

    return (
        <>
            <Helmet title={t('projects:transform_meta_title')} />
            <ErrorBoundary fallbackRender={props => <MissingDataErrorBoundary props={props} />}>
                <PageCardWrapper>
                    <TransformProjectFormProvider project={project}>
                        <ProjectFormHeading
                            title={t('projects:transform_project_title')}
                            schema={TransformProjectFormValidationSchema}
                            showConfirmationModal={showConfirmationModal}
                        />
                        <Divider direction="horizontal" />
                        <PageContent padding={0}>
                            <ScrollArea style={{height: '100%'}} scrollbar={<Scrollbar />}>
                                <TransformProjectFormSections canBeTransformed={project.status == 'open'} />
                            </ScrollArea>
                        </PageContent>
                        {isConfirmationModalVisible && (
                            <TransformProjectConfirmationModal projectId={project.id} hide={hideConfirmationModal} />
                        )}
                    </TransformProjectFormProvider>
                </PageCardWrapper>
            </ErrorBoundary>
        </>
    )
}
